// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"60d5db6b","239":"53db67cf","732":"6449a061"}[chunkId] + ".chunk.js";
};